/** QuickPlan — Barre flottante de la vue : vues, cadrage, gizmo, sélection par zone,
 *  outil de pose de fixations, ouvrir / fermer, affichages. */
import { useProjectStore } from '../store/useProjectStore.js';
import ExportGlbButton from '../components/ExportGlbButton.jsx';
import ExportStepButton from '../components/ExportStepButton.jsx';
import ExportStlButton from '../components/ExportStlButton.jsx';

const VIEWS = [
  { id: 'persp', label: '3D', title: 'Perspective (orbite) — 1' },
  { id: 'front', label: 'Face', title: 'Vue de face, orthogonale vers +Y — 2' },
  { id: 'top', label: 'Dessus', title: 'Vue de dessus, orthogonale — 3' },
  { id: 'right', label: 'Droite', title: 'Vue de droite, orthogonale — 4' },
];

export default function ViewBar() {
  const s = useProjectStore();
  const fixTypes = s.library.components.filter((c) => c.category === 'quincaillerie' && c.family === 'Fixations');
  const hiddenCount = s.project.instances.filter((i) => i.hidden).length + s.project.groups.filter((g) => g.hidden).length;
  const busy = !!s.ai.job;

  return (
    <div className="viewbar">
      <div className="seg">
        {VIEWS.map((v) => (
          <button key={v.id} className={s.view === v.id ? 'active' : ''} title={v.title} onClick={() => s.setView(v.id)}>{v.label}</button>
        ))}
      </div>
      <button title="Cadrer tout (F)" onClick={s.fit}>⤢</button>
      <div className="seg">
        <button className={s.tool === 'select' && s.gizmo === 'translate' ? 'active' : ''} title="Déplacer (G)" onClick={() => { s.setTool('select'); s.setGizmo('translate'); }}>✥</button>
        <button className={s.tool === 'select' && s.gizmo === 'rotate' ? 'active' : ''} title="Tourner (R)" onClick={() => { s.setTool('select'); s.setGizmo('rotate'); }}>⟳</button>
        <button className={s.boxMode ? 'active' : ''} title="Sélection par zone (B) — sinon Maj + glisser. Gauche → droite : entièrement dans le cadre ; droite → gauche : touché" onClick={() => s.toggle('boxMode')}>⬚ Zone</button>
      </div>
      <div className="seg">
        <button className={s.tool === 'fixation' ? 'active' : ''} disabled={busy} title="Poser une fixation : cliquez une face (Échap pour finir)" onClick={() => s.setTool(s.tool === 'fixation' ? 'select' : 'fixation')}>📌 Fixation</button>
        {s.tool === 'fixation' && (
          <select value={s.fixType} onChange={(e) => s.setFixType(e.target.value)} title="Type de fixation posée">
            {fixTypes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        )}
      </div>
      <div className="seg">
        <button disabled={busy} title="Ouvrir toutes les portes et tiroirs" onClick={() => s.setAllOpen(true)}>⟲ Ouvrir</button>
        <button disabled={busy} title="Fermer toutes les portes et tiroirs" onClick={() => s.setAllOpen(false)}>Fermer</button>
      </div>
      <div className="seg">
        <button className={s.showFixings ? 'active' : ''} title="Afficher les emplacements de fixation" onClick={() => s.toggle('showFixings')}>⊙ Vis</button>
        <button className={s.showPorts ? 'active' : ''} title="Afficher les points de connexion (P)" onClick={() => s.toggle('showPorts')}>● Ports</button>
        <button className={s.showEdges ? 'active' : ''} title="Afficher les arêtes" onClick={() => s.toggle('showEdges')}>▭ Arêtes</button>
      </div>
      <div className="seg">
        <ExportGlbButton label="⤓ glTF" />
        <ExportStepButton label="⤓ STEP" />
        <ExportStlButton label="⤓ STL" />
      </div>
      {hiddenCount > 0 && <button disabled={busy} title="Réafficher tout ce qui est masqué (Maj+H)" onClick={s.showAll}>👁 Tout afficher ({hiddenCount})</button>}
    </div>
  );
}
